import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CrudService } from "../../Services/crud.service";
import { LogedInUserService } from "../../Services/loged-in-user.service";
import { DatePipe } from "@angular/common";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UsageAnalyticDetailComponent } from "./usage-analytic-detail/usage-analytic-detail.component";
import { MatDialog } from "@angular/material/dialog";
import Sunburst from "sunburst-chart";
import * as d3 from "d3";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { LoadingService } from "src/app/Services/loading.service";

interface DataNode {
  name: string;
  children?: DataNode[];
  value?: number;
}
export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
  colors: string[];
  title: ApexTitleSubtitle;
};
@Component({
  selector: "app-usage-anayltics",
  templateUrl: "./usage-anayltics.component.html",
  standalone: false,
  styles: [
    `
      ::ng-deep .custom-modal .modal-dialog {
        width: 80% !important; // or width: 80%
      }
      ::ng-deep .monthwise-queries .apexcharts-bar-area {
        cursor: pointer;
      }

      ::ng-deep .modal-dialog {
        max-width: 90% !important;
        width: 80% !important;
      }
    `,
  ],
})
export class UsageAnaylticsComponent implements OnInit {
  id: string | null;
  @ViewChild("querymodal") querymodal;
  @ViewChild("usageanalyticChart", { static: true }) usageChartRef!: ElementRef;

  @ViewChild("visitedPagesTree") visitedPagesTree;
  data: any = [];
  usageDataBarChart: any = [];
  queriesData: any = [];
  feedback: {
    top5thumbsUpRefTypeWorkflowData: [];
    top5thumbsDownRefTypeWorkflowData: [];
    top5thumbsUpRefTypeFAQData: [];
    top5thumbsDownRefTypeFAQData: [];
    top5thumbsUpRefTypeUserguideData: [];
    top5thumbsDownRefTypeUserguideData: [];
    top5RatingsRefTypeWorkflowData: [];
    top5RatingsRefTypeFAQData: [];
    top5RatingsRefTypeUserguideData: [];
  };
  tableData;
  selectedMonth;
  popupMoth: any = "";
  mostAccessedData: any = [];
  navTreeData: any = null;
  mindTreeTabActive = false;
  versionList = [];
  allData = {};
  isLoading = false;
  filter = {
    selectedProject: "",
    selectedVersion: "",
    startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
      .toISOString()
      .slice(0, 10),
    endDate: new Date().toISOString().slice(0, 10),
  };
  closeResult = "";
  chartOptionsForpastQueriesData: Partial<ChartOptions>;
  chartOptionsforScreenwiseQueries: Partial<ChartOptions>;
  key = "";

  // Insights tab
  activeMainTab = 0;
  insightsScreenList: any[] = [];
  insightsModuleList: any[] = [];
  insightsFilter = { screenManagementId: "", moduleId: "" };
  insightsData: any[] = [];
  insightsLoading = false;
  open(content: TemplateRef<any>) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        backdrop: "static",
        keyboard: false,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return "by pressing ESC";
      case ModalDismissReasons.BACKDROP_CLICK:
        return "by clicking on a backdrop";
      default:
        return `with: ${reason}`;
    }
  }

  constructor(
    private translateService: TranslateService,
    private crudService: CrudService,
    private datePipe: DatePipe,
    private logedInUserService: LogedInUserService,
    private modalService: NgbModal,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private loadingService: LoadingService,
    private route: ActivatedRoute
  ) {
    this.id = this.route.snapshot.paramMap.get("id");
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    // this.isLoading = true;

    this.loadingService.show();
    this.getProjectManagementData(this.id);
    this.getPerDocwiseAnalytics();
    this.loadingService.hide();
  }

  getVersions(projectId) {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.versionList = response;
        self.filter.selectedVersion = response[0].id;
        self.applyFilter(false);
      },
      "Versions?filter[order]=created DESC&filter[where][projectManagementId]=" +
        projectId
    );
  }

  openUsageAnalyticDetail(response, type = "navigation"): void {
    this.closeModal();
    const dialogRef = this.dialog.open(UsageAnalyticDetailComponent, {
      width: "40%",
      height: "100%",
      panelClass: "custom-bg-panel",
      data: { response, isAnalytics: type === "chat" },
    });

    if (type == "chat") {
      dialogRef.componentInstance.isAnalytics = true;
    }
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  getProjectManagementData(id?) {
    this.logedInUserService.get((logedInUser) => {
      this.crudService.get(
        null,
        (response) => {
          if (response && response.length) {
            this.data = response;
            if (id) {
              this.filter.selectedProject = id;
              this.applyFilter(true);
              this.getQueryAnalyticsPerScreen();
              this.getQueryAnalysisofPastsixMonths();
            } else {
              this.filter.selectedProject = response[0].id;
              this.applyFilter(true);
              this.getQueryAnalyticsPerScreen();
              this.getQueryAnalysisofPastsixMonths();
            }
          } else {
            this.data = [];
          }
        },
        "projectManagements?filter[where][companyId]" +
          logedInUser.companyId +
          "&filter[order]=name ASC"
      );
    });
  }

  fetchData() {
    this.loadingService.show();
    var self = this;
    const filterQuery = this.buildFilterQuery();
    this.crudService.get(
      null,
      (response) => {
        if (response) {
          this.feedback = response || {};
          const feedbackGroups = [
            "top5thumbsUpRefTypeWorkflowData",
            "top5thumbsDownRefTypeWorkflowData",
            "top5thumbsUpRefTypeFAQData",
            "top5thumbsDownRefTypeFAQData",
            "top5thumbsUpRefTypeUserguideData",
            "top5thumbsDownRefTypeUserguideData",
            "top5RatingsRefTypeWorkflowData",
            "top5RatingsRefTypeFAQData",
            "top5RatingsRefTypeUserguideData",
          ];

          if (Array.isArray(feedbackGroups)) {
            feedbackGroups.forEach((group) => {
              const groupItems = this.feedback?.[group];
              if (Array.isArray(groupItems)) {
                groupItems.forEach((item) => {
                  this.thumbsUp(item);
                  this.thumbsDown(item);
                  this.calculateAverageRating(item);
                });
              } else {
                console.log("individual group items doesn't exist");
              }
            });
            this.loadingService.hide();
          } else {
            console.log("feedback group doesn't exist yet");
            this.loadingService.hide();
          }
        } else {
          this.feedback = {
            top5thumbsUpRefTypeWorkflowData: [],
            top5thumbsDownRefTypeWorkflowData: [],
            top5thumbsUpRefTypeFAQData: [],
            top5thumbsDownRefTypeFAQData: [],
            top5thumbsUpRefTypeUserguideData: [],
            top5thumbsDownRefTypeUserguideData: [],
            top5RatingsRefTypeWorkflowData: [],
            top5RatingsRefTypeFAQData: [],
            top5RatingsRefTypeUserguideData: [],
          };
          this.loadingService.hide();
        }
      },
      `feedbacks/topFiveData?${filterQuery}&limit=5`
    );
  }

  calculateAverageRating(item) {
    this.loadingService.show();

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length > 0) {
          // Filter out invalid ratings (e.g., empty strings or non-numeric values)
          const validRatings = response
            .map((rating) => parseInt(rating.rating, 10)) // Convert to integers
            .filter((rating) => !isNaN(rating)); // Filter out NaN (invalid ratings)

          const totalRatings = validRatings.length;

          if (totalRatings > 0) {
            // Sum of valid ratings
            const sumOfRatings = validRatings.reduce(
              (sum, rating) => sum + rating,
              0
            );

            // Calculate the average rating
            let averageRating = sumOfRatings / totalRatings;

            // Format the average rating: no decimal if whole number, else 1 decimal place
            item.ratingCount = Number.isInteger(averageRating)
              ? averageRating
              : averageRating.toFixed(1);
            this.loadingService.hide();
          } else {
            // No valid ratings, set ratingCount to 0
            item.ratingCount = 0;
            this.loadingService.hide();
          }
        } else {
          item.ratingCount = 0; // If no ratings, set to 0
          this.loadingService.hide();
        }
      },
      `feedbacks?filter[where][refId]=${item.refId}`
    );
  }

  thumbsUp(item) {
    this.loadingService.show();

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length > 0) {
          item.thumbsUpCount = response.length;
          this.loadingService.hide();
        } else {
          item.thumbsUpCount = 0;
          this.loadingService.hide();
        }
      },
      `feedbacks?filter[where][refId]=${item.refId}&filter[where][thumbsUp]=true`
    );
  }

  thumbsDown(item) {
    this.loadingService.show();

    this.crudService.get(
      null,
      (response) => {
        if (response && response.length > 0) {
          item.thumbsDownCount = response.length;
          this.loadingService.hide();
        } else {
          item.thumbsDownCount = 0;
          this.loadingService.hide();
        }
      },
      `feedbacks?filter[where][refId]=${item.refId}&filter[where][thumbsDown]=true`
    );
  }

  fetchAllData(key) {
    this.loadingService.show();

    this.key = key;
    var self = this;
    const filterQuery = this.buildFilterQuery();
    self.crudService.get(
      null,
      (response) => {
        if (response) {
          self.allData = response;
          const feedbackGroups = [
            "top5thumbsUpRefTypeWorkflowData",
            "top5thumbsDownRefTypeWorkflowData",
            "top5thumbsUpRefTypeFAQData",
            "top5thumbsDownRefTypeFAQData",
            "top5thumbsUpRefTypeUserguideData",
            "top5thumbsDownRefTypeUserguideData",
            "top5RatingsRefTypeWorkflowData",
            "top5RatingsRefTypeFAQData",
            "top5RatingsRefTypeUserguideData",
          ];

          if (Array.isArray(feedbackGroups)) {
            feedbackGroups.forEach((group) => {
              const groupItems = self.allData?.[group];

              if (Array.isArray(groupItems)) {
                groupItems.forEach((item) => {
                  self.thumbsUp(item);
                  self.thumbsDown(item);
                  self.calculateAverageRating(item);
                });
                this.loadingService.hide();
              } else {
                console.log("inside group doesn't exist 2");
                this.loadingService.hide();
              }
            });
          }
        } else {
          self.allData = {};
          console.log("main data doesn't exist");
          this.loadingService.hide();
        }
      },
      `feedbacks/topFiveData?${filterQuery}&top5Data=${key}`
    );
  }

  buildFilterQuery() {
    let query = "";

    if (this.filter.selectedProject) {
      query += `projectManagementId=${this.filter.selectedProject}`;
    }
    if (this.filter.selectedVersion) {
      query += `&projectVersion=${this.filter.selectedVersion}`;
    }
    if (this.filter.startDate) {
      query += `&startDate=${this.datePipe.transform(
        this.filter.startDate,
        "yyyy-MM-dd"
      )}`;
    }
    if (this.filter.endDate) {
      query += `&endDate=${this.datePipe.transform(
        this.filter.endDate,
        "yyyy-MM-dd"
      )}`;
    }

    return query;
  }

  applyFilter(getVersion) {
    this.loadingService.show();

    if (getVersion && this.filter.selectedProject) {
      this.getVersions(this.filter.selectedProject);
      this.loadInsightsScreens(this.filter.selectedProject);
    }
    if (!this.filter.startDate) {
      this.toastr.error("Please select start date.", "Invalid Operation");
      return;
    }
    if (!this.filter.endDate) {
      this.toastr.error("Please select end date.", "Invalid Operation");
      return;
    }
    this.fetchData();
    this.fetchSunBurstData();
    this.fetchBarChartData();
    this.loadingService.hide();
  }

  fetchSunBurstData() {
    var self = this;
    this.loadingService.show();

    const filterQuery = this.buildFilterQuery();
    this.crudService.get(
      null,
      (response) => {
        if (response != "No Data Found") {
          this.navTreeData = response;
          this.chart(response);
          this.loadingService.hide();
        } else {
          this.navTreeData = null;
          const element = document.getElementById("usageanalytic-chart");
          element.innerHTML =
            '<strong style="margin: -425px;">No Data Available</strong>';
          this.loadingService.hide();
        }
      },
      `usageAnalytics/getUsageAnalytic?${filterQuery}`
    );
  }

  fetchBarChartData() {
    this.loadingService.show();

    const filterQuery = this.buildFilterQuery();
    this.crudService.get(
      null,
      (response) => {
        // this.isLoading = false;
        if (response != "No Data Found") {
          this.usageDataBarChart = response;
          this.loadingService.hide();
        } else {
          this.usageDataBarChart = [];
        }
        this.loadingService.hide();
      },
      `usageAnalytics/getUsageAnalyticBarChart?${filterQuery}`
    );
  }

  chart(usageData) {
    this.loadingService.show();

    const element = document.getElementById("usageanalytic-chart");
    element.innerHTML = "";
    const myChart = new Sunburst(element); // <- Use 'new' here
    const color = d3.scaleOrdinal(d3.schemePaired);

    myChart
      .data(usageData)
      .height(750)
      .width(800)
      .label("name")
      .size("value")
      .color((d) => color(d.name))
      .onClick((node: any) => {
        updateLegend(node);
        myChart.focusOnNode(node);
      });

    updateLegend(usageData);

    function updateLegend(node: DataNode) {
      const legend = d3.select("#usageanalytic-legend").selectAll("*").remove();

      const legendSvg = d3
        .select("#usageanalytic-legend")
        .append("svg")
        .attr("width", "100%")
        .attr("height", node.children ? node.children.length * 20 : 0);

      const legendItem = legendSvg
        .selectAll("g")
        .data(node.children || [])
        .enter()
        .append("g")
        .attr("transform", (d, i) => `translate(0, ${i * 20})`);

      legendItem
        .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", 18)
        .attr("height", 18)
        .style("fill", (d: DataNode) => color(d.name));

      legendItem
        .append("text")
        .attr("x", 24)
        .attr("y", 9)
        .attr("dy", ".35em")
        .text((d: DataNode) => d.name);
    }
    this.loadingService.hide();
  }

  // ApexCharts renders a category as multiple tspans when given as a string
  // array, so a long question wraps onto its own lines instead of being
  // rotated/overlapping as a single long label.
  private wrapAxisLabel(text: string, maxCharsPerLine = 14, maxLines = 3): string[] {
    const words = (text || "").split(" ");
    const lines: string[] = [];
    let current = "";
    words.forEach((word) => {
      const candidate = current ? `${current} ${word}` : word;
      if (candidate.length > maxCharsPerLine && current) {
        lines.push(current);
        current = word;
      } else {
        current = candidate;
      }
    });
    if (current) lines.push(current);

    if (lines.length > maxLines) {
      const trimmed = lines.slice(0, maxLines);
      trimmed[maxLines - 1] = trimmed[maxLines - 1].replace(/\s*\S*$/, "") + "...";
      return trimmed;
    }
    return lines;
  }

  getQueryAnalyticsPerScreen() {
    this.loadingService.show();
    const filterQuery = this.buildFilterQuery();
    const query = {
      projectManagementId: this.filter?.selectedProject
        ? this.filter?.selectedProject
        : this.id,
      startDate: this.filter.startDate,
      endDate: this.filter.endDate,
      projectVersion: this.filter.selectedVersion,
    };

    this.crudService.get(
      null,
      (data) => {
        const categories = Array.from(new Set(data.map((item) => item.query)));

        // Group data per screen
        const screenMap: Record<string, number[]> = {};

        if (Array.isArray(data)) {
          data.forEach((item) => {
            if (!screenMap[item.screenName]) {
              // initialize with 0s so categories align
              screenMap[item.screenName] = new Array(categories.length).fill(0);
            }
            const queryIndex = categories.indexOf(item.query);
            if (queryIndex !== -1) {
              screenMap[item.screenName][queryIndex] += item.count;
            }
          });
        } else {
          console.log("query analytics per screen does not exist yet");
        }

        const series = Object.keys(screenMap).map((screen) => ({
          name: screen,
          data: screenMap[screen],
        }));
        this.chartOptionsforScreenwiseQueries = {
          series,
          chart: { type: "bar", height: 500 },
          xaxis: {
            categories: categories.map((c) => this.wrapAxisLabel(c as string)),
            labels: { rotate: 0, trim: false, style: { fontSize: "11px" } },
          },
          // The x-axis category is wrapped/truncated for the tick label, so
          // show the full original question in the hover tooltip instead of
          // repeating the same truncated text.
          tooltip: {
            x: {
              formatter: (_value: any, opts: any) =>
                categories[opts?.dataPointIndex] as string,
            },
          },
          dataLabels: { enabled: true },
          title: { text: "Screenwise Query Counts" }, // TS may need type adjustment
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "5%",
            },
          },
          yaxis: {
            min: 0,
            max: 12, // make same as right chart if you want equal height
            tickAmount: 6,
          },
        };

        this.loadingService.hide();
      },

      `usageAnalytics/queriesByScreen?${filterQuery}`
    );
  }
  groupedData;
  getQueryAnalysisofPastsixMonths() {
    this.loadingService.show();
    const filterQuery = this.buildFilterQuery();
    this.crudService.get(
      null,
      (response) => {
        if (response) {
          this.queriesData = response;

          const months = Object.keys(response);
          const counts = months.map((m) => response[m].abstractInfo.totalCount);

          this.chartOptionsForpastQueriesData = {
            series: [
              {
                name: "Queries",
                data: counts,
              },
            ],
            chart: {
              type: "bar",
              height: 350,
              events: {
                dataPointSelection: (event, chartContext, config) => {
                  const dataPointIndex = config.dataPointIndex;
                  const category = months[dataPointIndex];
                  const value = counts[dataPointIndex];

                  // Drilldown to queries
                  this.onBarClick(category, response[category].askedQuestion);
                },
              },
            },
            plotOptions: {
              bar: { horizontal: false, columnWidth: "5%", borderRadius: 5 },
            },
            stroke: { show: true, width: 2, colors: ["#032d55"] },
            xaxis: { categories: months },
            yaxis: { title: { text: "Count" } },
            fill: { opacity: 1 },
            colors: ["#032d55"],
          };

          this.groupedData = response; // store raw grouped data for drilldown
        }
        this.loadingService.hide();
      },
      `usageAnalytics/recent-six-months?${filterQuery}`
    );
  }
  onBarClick(month: string, value: number) {
    this.popupMoth = month;
    this.tableData = Object.entries(this.groupedData[month].askedQuestion).map(
      ([id, value]) => ({
        id,
        query: value["query"]["query"],
        count: value["count"],
        screenName: value["screenName"],
      })
    );
    const modalRef = this.modalService
      .open(this.querymodal, {
        ariaLabelledBy: "modal-basic-title",
        backdrop: "static",
        keyboard: false,
        size: "lg",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  getPerDocwiseAnalytics() {
    this.loadingService.show();
    this.crudService.get(
      null,
      (response) => {
        this.mostAccessedData = response;
        console.log("response", response);
        this.loadingService.hide();
      },
      "usageAnalytics/most-fetched-data"
    );
  }
  onNavTabChange(event: any) {
    // reserved for future tab logic
  }


  onMainTabChange(index: number) {
    this.activeMainTab = index;
    if (index === 1 && this.filter.selectedProject) {
      this.loadInsightsScreens(this.filter.selectedProject);
      this.loadChatInsights();
    }
  }

  loadInsightsScreens(projectId: string) {
    this.crudService.get(
      null,
      (response) => {
        this.insightsScreenList = response || [];
        this.insightsFilter.screenManagementId = "";
        this.insightsFilter.moduleId = "";
        this.loadInsightsModules(projectId);
      },
      `screenManagements?filter[where][projectId]=${projectId}&filter[fields][id]=true&filter[fields][name]=true&filter[fields][module]=true&filter[order]=name ASC`
    );
  }

  loadInsightsModules(projectId: string) {
    this.crudService.get(
      null,
      (response) => {
        this.insightsModuleList = response || [];
      },
      `modules?filter[where][projectManagementId]=${projectId}&filter[order]=name ASC`
    );
  }

  loadChatInsights() {
    this.insightsLoading = true;
    let url = `usageAnalytics/getChatInsights?projectManagementId=${this.filter.selectedProject}`;
    if (this.insightsFilter.screenManagementId) {
      url += `&screenManagementId=${this.insightsFilter.screenManagementId}`;
    }
    if (this.insightsFilter.moduleId) {
      url += `&moduleId=${this.insightsFilter.moduleId}`;
    }
    this.crudService.get(
      null,
      (response: any[]) => {
        this.insightsData = response || [];
        this.insightsLoading = false;
      },
      url
    );
  }

  openFullAnalytics() {
    const modalRef = this.modalService
      .open(this.visitedPagesTree, {
        ariaLabelledBy: "modal-basic-title",
        backdrop: "static",
        keyboard: false,
        size: "xl",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
}
